module.exports = __webpack_public_path__ + "img/login-logo.5763b01b.png";